import React from "react";
import { FaShieldAlt, FaUndoAlt, FaLeaf } from "react-icons/fa";

const TrustBadgesFooter = ({ className = "" }) => {
  return (
    <div
      className={`py-4 my-2 flex flex-wrap items-center justify-center gap-6 text-xs font-medium text-[#046a38] ${className}`}
    >
      <div className="flex items-center gap-1.5">
        <FaShieldAlt className="h-4 w-4" />
        <span>100% Secure Payments</span>
      </div>
      <div className="flex items-center gap-1.5">
        <FaUndoAlt className="h-4 w-4" />
        <span>Easy Returns</span>
      </div>
      <div className="flex items-center gap-1.5">
        <FaLeaf className="h-4 w-4" />
        <span>Farm Fresh. Delivered to Your Doorstep.</span>
      </div>
    </div>
  );
};

export default TrustBadgesFooter;
